export default __webpack_public_path__ + "static/media/fb.357ffac8.png";